export class User {
  id?: number;
  email: string;
  password?: string
  role: any;
  username: string;
  constructor() {
    this.id = 0;
    this.email = '';
  }
}